import { render, staticRenderFns } from "./ResortListPaginate.vue?vue&type=template&id=5f83a7b1"
import script from "./ResortListPaginate.vue?vue&type=script&lang=js"
export * from "./ResortListPaginate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.6.14_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports